import {useLocale} from "i18n";
import Seo from "../seo/Seo";
import {AdvertisingContent} from "../home/landing/AdvertisingContent";
import {advertisingCopy} from "../home/landing/copy/advertising";
import {ADVERTISING_PATH} from "../sponsor/sponsorRoutes";

/**
 * Public, pre-rendered **Advertising** presentation page (`/advertising`).
 *
 * Thin wrapper (mirrors {@link ./P2PRoute.tsx}): `<Seo>` plus the page body. SEO strings and copy live
 * in {@link ../home/landing/copy/advertising.ts}, so a content edit touches that module and nothing
 * here. The canonical URL is derived from `path` per active locale by `<Seo>`, so the `/ro` mirror
 * needs no separate wiring.
 *
 * Indexable, and listed in the sitemap: this is now the entry point for somebody looking to buy a
 * takeover, which the booking form used to be.
 */
export function Component() {
	const {locale} = useLocale();
	const {seo} = advertisingCopy[locale];
	return (
		<>
			<Seo title={seo.title} description={seo.description} path={ADVERTISING_PATH}/>
			<AdvertisingContent/>
		</>
	);
}
